import MsisdnSearchStripper from "../../utils/MsisdnSearchStripper";
import * as ValidationRule from "../../utils/ValidationRule";
import * as yup from "yup";

export default class RegistrationCreationRequest {

    constructor(jsonResponse) {
        this.city = jsonResponse["city"];
        this.dob = jsonResponse["dob"];
        this.documents = jsonResponse["documents"];
        this.firstName = jsonResponse["first-name"];
        this.gender = jsonResponse["gender"];
        this.idExpiryDate = jsonResponse["id-expiry-date"];
        this.idNumber = jsonResponse["id-number"];
        this.idType = jsonResponse["id-type"];
        this.lastName = jsonResponse["last-name"];
        this.msisdn = jsonResponse["msisdn"];
        this.nationality = jsonResponse["nationality"];
        this.postalCode = jsonResponse["postal-code"];
        this.street = jsonResponse["street"];
        this.town = jsonResponse["town"];
        this.province = jsonResponse["province"];
        this.email = jsonResponse["email-address"];
        this.cardRequested = jsonResponse["card-requested"];
        this.title = jsonResponse["title"];
        this.ethnicity = jsonResponse["ethnicity"];
        this.idIssueDate = jsonResponse["id-issue-date"];
        this.unit = jsonResponse["unit"];
        this.complexName = jsonResponse["complex-name"];
        this.sourceOfFunds = jsonResponse["source-of-funds"];
    }

    static toJson = function (item) {
        let jsonObj = {};
        jsonObj["city"] = item.city;
        jsonObj["dob"] = item.dob;
        jsonObj["documents"] = item.documents;
        jsonObj["first-name"] = item.firstName;
        jsonObj["gender"] = item.gender;
        jsonObj["id-expiry-date"] = item.idExpiryDate;
        jsonObj["id-number"] = item.idNumber;
        jsonObj["id-type"] = item.idType;
        jsonObj["last-name"] = item.lastName;
        jsonObj["msisdn"] = MsisdnSearchStripper.stripMsisdn(item.msisdn);
        jsonObj["nationality"] = item.nationality;
        jsonObj["postal-code"] = item.postalCode;
        jsonObj["street-number"] = item.streetNumber;
        jsonObj["street"] = item.streetName;
        jsonObj["town"] = item.town;
        jsonObj["province"] = item.province;
        jsonObj["email-address"] = item.email;
        jsonObj["card-requested"] = item.cardRequested;
        jsonObj["title"] = item.title;
        jsonObj["ethnicity"] = item.ethnicity;
        jsonObj["id-issue-date"] = item.idIssueDate;
        jsonObj["unit"] = item.unit;
        jsonObj["complex-name"] = item.complexName;
        jsonObj["source-of-funds"] = item.sourceOfFunds;
        return jsonObj;
    };

    static retrieveNewRegistrationValidationConfig() {

        let validationRules = {
            firstName: ValidationRule.getAlphaSpaceValidator("First Name", true, 5),
            lastName: ValidationRule.getAlphaSpaceValidator("Last Name", true, 5),
            gender: ValidationRule.getStringRule("Gender", true),
            DOB: ValidationRule.getDOBValidator("Date of Birth", true),
            phoneNumber: ValidationRule.getCellphoneNumberRule("Phone number", true),
            idType: ValidationRule.getStringRule("Id Type", true),
            idNumber: ValidationRule.getStringRule("Id Number", true), // NON-SA_ID
            idExpiryDate: ValidationRule.getIdExpiryDateValidator("Id expiry date", true),
            country: ValidationRule.getStringRule("Country", true),
            streetNumber: ValidationRule.getNumericRule("Street Number", true),
            streetName: ValidationRule.getStringRule("Street Name", true),
            town: ValidationRule.getStringRule("Town", true),
            city: ValidationRule.getStringRule("City", true, 3),
            province: ValidationRule.getStringRule("Province", true),
            postalCode: ValidationRule.getPostalCodeRule("Postal Code", true),
            email: ValidationRule.getEmailAddressRule("Email Address", false),
            cardRequested: ValidationRule.getStringRule("Card option", true),
            staysInComplex: ValidationRule.getStringRule("Complex", true),
            idIssueDate: ValidationRule.getIdIssueDateValidator("Id issue date", true),
            title: ValidationRule.getStringRule("Title", true),
            ethnicity: ValidationRule.getStringRule("Ethnicity", true),
            unit: ValidationRule.getNumericRule("Unit", true),
            complexName: ValidationRule.getStringRule("Complex Name", true),
            sourceOfFunds: ValidationRule.getStringRule("Source Of Funds", true),
        };

        this.schema = {};
        Object.keys(validationRules).forEach(key => {
            let shapeWrapper = {
                [key]: validationRules[key]
            };

            this.schema[key] = yup.object().shape(shapeWrapper);
        });

        return this.schema;

    }

    static retrieveEmailRequiredValidationConfig(required){
        return yup.object().shape({
            email: ValidationRule.getEmailAddressRule("Email Address", required)
        });
    }

    static retrieveSAIDValidationConfig() {
        return yup.object().shape({
            idNumber: ValidationRule.getSAIDNumberValidatorBeforeDobGender("Id Number", true)
        });
    }

    static retrieveNonSAIDValidationConfig() {
        return yup.object().shape({
            idNumber: ValidationRule.getStringRule("Id Number", true),
        });
    }

    static retrieveCountryValidationConfig() {
        return yup.object().shape({
            country: ValidationRule.getNationalityRule("Country", true),
        });
    }


}